// excludes field(s) without value
export const sanitizeObject = (payload, excludedKeys = []) => {
  return Object.keys(payload)
    .filter(
      (k) =>
        typeof payload[k] === "boolean" ||
        !!payload[k] ||
        !excludedKeys.includes(k)
    )
    .reduce((a, k) => ({ ...a, [k]: payload[k] }), {});
};
